
const settingsKey = "user-settings";

const ALL_SETTINGS = ["Show precise stars", "Show Forbidden Book", "Show Scatterplot Averages"] as const;
type settingName = (typeof ALL_SETTINGS)[number]

const settingDescriptions: Record<settingName, string> = {
    "Show precise stars": "Display the unrounded star values for players. (Scatterplots always use precise values)",
    "Show Forbidden Book": "Enable the Forbidden Book explorer (may reveal Story-related Forbidden Knowledge)",
    "Show Scatterplot Averages": "Mark average values on team scatterplots."
}

interface baseSetting {
    _type: string;
    _name: settingName;
}

type booleanSetting = baseSetting & {
    _type: "boolean",
    value: boolean
}
type stringSetting = baseSetting & {
    _type: "string",
    value: string
}

export type Setting = booleanSetting | stringSetting


const defaultSettings: Setting[] = [
    {
        _type: "boolean",
        _name: "Show precise stars",
        value: false
    }, {
        _type: "boolean",
        _name: "Show Forbidden Book",
        value: false
    }, {
        _type: "boolean",
        _name: "Show Scatterplot Averages",
        value: false
    }
]

function validateSettings(settings: Setting[]) {
    const observedNames: settingName[] = []
    settings.forEach(setting => {
        if (observedNames.includes(setting._name)) {
            alert("Error saving settings")
            console.warn(`Settings object has repeat key ${setting._name}`)
            console.log(settings)
            return false;
        }
        observedNames.push(setting._name)
    })
    return true;
}

const getSettings = (): Setting[] => {
    const current = localStorage.getItem(settingsKey)
    if (current) {
        const saved: Setting[] = JSON.parse(current)
        const savedList = saved.map(setting => setting._name);
        defaultSettings.forEach(setting => {
            if (!savedList.includes(setting._name)) {
                saved.push(setting)
            }
        });
        return saved;
    }
    console.log("failed to load settings")
    return defaultSettings;
}

const saveSettings = (settings: Setting[]) => {
    if (validateSettings(settings)) {
        localStorage.setItem(settingsKey, JSON.stringify(settings))
    }
}

const lookupSetting = (name: settingName, settings: Setting[]) => {
    const matches = settings.filter(setting => setting._name === name);
    if (matches.length === 1) {
        return matches[0].value;
    }
    console.warn(`Tried to look up setting[${name}], but got ${matches.length} matches`)
    console.log(settings);
}

export const Settings = {
    getSettings,
    saveSettings,
    settingDescriptions,
    lookupSetting
}